<template>
  <div class="VideoContainer">

    <video width="100%" ref="vidEl" class="videoEl" playsinline preload>
      <source :src="vid" type="video/mp4">
        Your browser does not support the video tag.
    </video>

  </div>
</template>

<script>

//import component from '@assets/components/component.vue'
import { eventBus } from '@/utils'

export default {
  name: 'VideoContainer',
  components: {
    //component
  },
  props: {
    filename: String,
    elref: {default: null},
  },
  data: function () {
    return {
      scroll: Number
    }
  },
  computed: {
    vid: function () {
      return require('@/assets/' + this.filename)
    },
  },
  methods: {
    setCallbacks: function () {
    },
    onScroll: function (scrollTop) {
      this.scroll = this.elref.$el.getBoundingClientRect().top
      this.playTest();
    },
    playTest: function () {
      if(this.scroll <= 0 && this.$refs.vidEl.paused && !this.$refs.vidEl.ended){
        this.$refs.vidEl.play()
      }
    }
  },
  created: function () {
    eventBus.$on('scroll',(e) => {
      this.onScroll(e.srcElement.scrollTop)
    });
  },
  mounted: function () {
    this.$refs.vidEl.muted = true;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.VideoContainer{
  width: 100%;
  max-width: 600px;
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

</style>
